import { Link } from "react-router-dom";

interface SectionHeadingProps {
  eyebrow: string;
  title: string;
  description?: string;
  actionLabel?: string;
  actionTo?: string;
}

export default function SectionHeading({
  eyebrow,
  title,
  description,
  actionLabel,
  actionTo,
}: SectionHeadingProps) {
  return (
    <div className="flex flex-col gap-4 md:flex-row md:items-end md:justify-between">
      <div className="max-w-2xl">
        <div className="flex items-center gap-2 text-xs font-label font-medium uppercase tracking-[0.2em] text-primary-600">
          <span className="inline-block h-[2px] w-6 bg-primary-500" aria-hidden="true" />
          {eyebrow}
        </div>
        <h2 className="mt-3 font-heading text-2xl font-bold leading-snug text-foreground-950 md:text-[32px]">
          {title}
        </h2>
        {description ? (
          <p className="mt-3 text-sm leading-relaxed text-foreground-600 md:text-[15px]">
            {description}
          </p>
        ) : null}
      </div>
      {actionLabel && actionTo ? (
        <Link
          to={actionTo}
          className="group inline-flex w-fit items-center gap-2 whitespace-nowrap rounded-md border border-background-300 px-4 py-2 text-sm font-medium text-foreground-800 transition-colors hover:border-primary-400 hover:text-primary-700"
        >
          {actionLabel}
          <i className="ri-arrow-right-line transition-transform group-hover:translate-x-1" />
        </Link>
      ) : null}
    </div>
  );
}